import Client from "./Client";
// import RequestList from "./RequestList";

const FaxesService = {
    url: 'admin/faxes',
    getDefault(){
        return {
            id : undefined,
            to : undefined,
            file_id : undefined,
            status : undefined,
            tries : undefined,
            attempts : undefined,
            callback_url : undefined,
            description : undefined,
            completed_at : undefined,
            created_at : undefined
        }
    },
    /**
     * @params RequestList requestList
     * @return Request Promise
     **/
    async list(requestList) {
        return await Client.get(`${this.url}`, requestList.json());
    },
    /**
     * @params RequestList requestList
     * @return Request Promise
     **/
    async faxActivities(faxId, requestList) {
        return await Client.get(`${this.url}/${faxId}/activities`, requestList.json());
    },
    /**
     * @params category
     * @return Request Promise
     **/
    async create(fax) {
        return await Client.post(`${this.url}`, fax);
    },

    /**
     * @params category
     * @return Request Promise
     **/
    async retryIncoming(fax) {
        return await Client.post(`${this.url}/${fax.id}/retry-incoming`, fax);
    },

    /**
     * @params time_dimension
     * @params [] filters
     * @return Request Promise
     **/
    async getOverviewReport(time_dimension, filters) {
        return await Client.get(`${this.url}/reports/overview`, {
            time_dimension,
            filters
        });
    }
}

export default FaxesService